import { Button } from "primereact/button"
import gpraStyles from "../../../styles/Participant-GPRA.module.css"
import { useContext, useRef } from "react"
import axios from "axios"
import { gpraUrl } from "../../../config/microservicesUrls"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { useState } from "react"
import { showMessage } from "../utils/utils"
import { Dialog } from "primereact/dialog"
import { RELOAD_TYPES } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"
import { Tooltip } from "primereact/tooltip"

const DeleteGpraRecord = ({
  gpra_record_id,
  setReloadStatus,
  ableToDelete,
  startedIntake,
  startedFollowUp,
  startedDischarge,
  completedIntake,
  completedFollowUp,
  completedDischarge,
  blocked,
}) => {
  const toast = useRef()
  const [confirmation, setConfirmation] = useState(false)
  const userCtx = useContext(UserContext)

  const setLegend = () => {
    let legend = "Note: GPRA Record is able to be deleted"
    if (!ableToDelete) {
      legend = "Unable to delete GPRA Record - The record is not empty."
    }
    return legend
  }
  const setIntakeStatus = () => {
    let intakeStatus = " Intake: "
    if (!ableToDelete) {
      if (startedIntake) {
        if (completedIntake) {
          intakeStatus += "Complete"
        } else {
          intakeStatus += "Partially completed"
        }
      }
    }
    return intakeStatus
  }
  const setFollowUpStatus = () => {
    let followUpStatus = " Follow Up: "
    if (!ableToDelete) {
      if (startedFollowUp) {
        if (completedFollowUp) {
          followUpStatus += "Complete"
        } else {
          followUpStatus += "Partially completed"
        }
      } else {
        followUpStatus += "Incomplete"
      }
    }
    return followUpStatus
  }
  const setDischargeStatus = () => {
    let dischargeStatus = " Discharge: "
    if (!ableToDelete) {
      if (startedDischarge) {
        if (completedDischarge) {
          dischargeStatus += "Complete"
        } else {
          dischargeStatus += "Partially completed"
        }
      } else {
        dischargeStatus += "Incomplete"
      }
    }
    return dischargeStatus
  }
  const deleteRecord = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${userCtx.tokens.getGpraToken()}`,
      },
    }
    axios
      .post(
        `${gpraUrl()}${endpoints.DELETE_GPRA_RECORD}`,
        {
          gpra_record_id: gpra_record_id,
          staff_uuid: userCtx.session.user.staff_id,
          staff_role: userCtx.session.user.staff_role,
        },
        config,
      )
      .then((response) => {
        if (response.status === 200) {
          setReloadStatus(RELOAD_TYPES.deleteRecord)
          showMessage(true, "Gpra Record successfully deleted", toast)
          setConfirmation(false)
        }
      })
      .catch((err) => {
        console.log("err", err)
        showMessage(false, "Unable to create Gpra Record", toast)
      })
  }
  const modalFooter = () => {
    return (
      <>
        <Button
          label="Delete"
          style={{ backgroundColor: "red" }}
          onClick={() => {
            deleteRecord()
          }}
        />
        <Button
          label="Cancel"
          onClick={() => {
            setConfirmation(false)
          }}
        />
      </>
    )
  }
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginLeft: "1rem",
      }}
    >
      <p
        style={{
          display: "inline-block",
        }}
      ></p>
      <div
        className={gpraStyles.interviewCardButton}
        style={{ paddingRight: "0rem" }}
      >
        {!ableToDelete && userCtx.session.user.staff_role !== 1 && (
          <>
            <Tooltip
              target=".custom-target-icon-delete"
              position="left"
              className="custom-tooltip"
            >
              <p style={{ fontSize: "16px" }}>
                <i>{setLegend()}</i>
                {!ableToDelete && (
                  <ul
                    style={{
                      listStyle: "initial",
                      listStyleType: "square",
                      marginLeft: "2rem",
                    }}
                  >
                    <li>{setIntakeStatus()}</li>
                    <li>{setFollowUpStatus()}</li>
                    <li>{setDischargeStatus()}</li>
                  </ul>
                )}
              </p>
            </Tooltip>
            <i
              className={`${"custom-target-icon-delete pi pi-envelope p-text-secondary pi-info-circle"} ${
                gpraStyles.interviewCardButtonTooltipIcon
              }`}
            ></i>
          </>
        )}

        <Button
          label="Delete GPRA Record"
          disabled={!ableToDelete && userCtx.session.user.staff_role !== 1}
          className={gpraStyles.interviewStatusCardButton}
          onClick={() => {
            setConfirmation(true)
          }}
        />
      </div>
      <Dialog
        visible={confirmation}
        onHide={() => setConfirmation(false)}
        className={gpraStyles.createRecordConfirmationDialog}
        modal
        footer={!blocked && modalFooter()}
        header={!blocked && "Delete GPRA Record"}
      >
        {blocked ? (
          <p
            className="m-0"
            style={{
              marginBottom: "1rem",
              marginTop: "1rem",
              fontSize: "16px",
            }}
          >
            Some background sync/save jobs are still running, please try again
            in a few minutes
          </p>
        ) : (
          <label>Are you sure you want to proceed?</label>
        )}
      </Dialog>
    </div>
  )
}
export default DeleteGpraRecord
